import React from 'react';
import Layout from './Layout';

const NoMatch = () => {
  return (
    <Layout>
      <strong>Page not found!</strong>
    </Layout>
  );
};

export default NoMatch;
